import React, { Component, createRef } from "react";
import DownloadResults from "./DownloadResults";

class ImageReceipt extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = createRef();
    this.state = {
      rawText: [],
      summaryData: [],
      itemsData: [],
      messages: {
        text: (
            <div className="no-analysis">
                <p>No text was found</p>
            </div>
        ),
        forms: (
            <div className="no-analysis">
                <p>FORM Analysis is Not Enabled.</p>
                <p>If Image contains a FORM : Enable Checkbox and Re-Upload Image</p>
            </div>
        ),
        tables: (
            <div className="no-analysis">
                <p>TABLE Analysis is Not Enabled.</p>
                <p>If Image contains a TABLE : Enable Checkbox and Re-Upload Image</p>
            </div>
        ),
        receiptSummary: (
            <div className="no-analysis">
                <p>Receipt Analysis is Not Enabled.</p>
                <p>If Image contains a Receipt : Enable Checkbox and Re-Upload Image</p>
            </div>
        ),
        receiptItems: (
            <div className="no-analysis">
                <p>Receipt Analysis is Not Enabled.</p>
                <p>If Image contains a Receipt : Enable Checkbox and Re-Upload Image</p>
            </div>
        )
      },
      summaryPair: '',
      itemsPair: '',
      formsPair: '',
      tablesPair: '',
      rawJson: [],
    };
  }

  componentDidMount() {
    this.processImageReceipt(this.props.data);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data || prevProps.file_url !== this.props.file_url) {
      this.processImageReceipt(this.props.data);
    }
  }

  drawBoundingBox = (ctx, x, y, width, height) => {
    ctx.beginPath();
    ctx.rect(x, y, width, height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "red";
    ctx.stroke();
  };

  processImageReceipt = (data) => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.src = this.props.file_url;

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, img.width, img.height);

      let parsedData = [];
      if (typeof data === "string") {
          try {
              parsedData = JSON.parse(data);
          } catch (err) {
              console.error("Failed to parse data:", err);
              parsedData = [];
          }
      } else if (Array.isArray(data)) {
          parsedData = data;
      }

      this.setState({ rawJson: parsedData });

      data = parsedData;
      
      let rawText = [];
      let summaryData = [];
      let itemsData = [];
      let messages = { ...this.state.messages };
      let summaryPair = '';
      let itemsPair = '';

      if (!data || data.length === 0) {
        messages.text = (
            <div className="no-analysis">
                <p>No text was found</p>
            </div>
        );
        messages.forms = (
            <div className="no-analysis">
                <p>No forms was found</p>
            </div>
        );
        messages.tables = (
            <div className="no-analysis">
                <p>No tables was found</p>
            </div>
        ); 
        messages.receiptSummary = (
            <div className="no-analysis">
                <p>No receipts was found</p>
            </div>
        );
        messages.receiptItems = (
            <div className="no-analysis">
                <p>No items was found</p>
            </div>
        );

        this.setState({ rawText, summaryData, itemsData, messages });
        return;
      }

      data.forEach((receipt, i) => {
        rawText.push([]);

        // Process SummaryFields
        receipt.SummaryFields.forEach((field) => {
          if (field.LabelDetection) {
            const x = field.LabelDetection.Geometry.BoundingBox.Left * img.width;
            const y = field.LabelDetection.Geometry.BoundingBox.Top * img.height;
            const width = field.LabelDetection.Geometry.BoundingBox.Width * img.width;
            const height = field.LabelDetection.Geometry.BoundingBox.Height * img.height;
            this.drawBoundingBox(ctx, x, y, width, height);

            rawText[i].push(field.LabelDetection.Text);
          }

          if (field.ValueDetection) {
            const x = field.ValueDetection.Geometry.BoundingBox.Left * img.width;
            const y = field.ValueDetection.Geometry.BoundingBox.Top * img.height;
            const width = field.ValueDetection.Geometry.BoundingBox.Width * img.width;
            const height = field.ValueDetection.Geometry.BoundingBox.Height * img.height;
            this.drawBoundingBox(ctx, x, y, width, height);

            rawText[i].push(field.ValueDetection.Text);
          }

          // Summary data
          if (field.Type.Text === "VENDOR_NAME") {
            summaryData.push({ key: "VENDOR_NAME", value: field.ValueDetection?.Text || "" });

            summaryPair += `VENDOR_NAME,${field.ValueDetection.Text}\n`;
            summaryPair += '\n';
          } else if (field.LabelDetection && field.ValueDetection) {
            summaryData.push({ key: field.LabelDetection.Text, value: field.ValueDetection.Text });

            summaryPair +=  field.LabelDetection.Text + "," + field.ValueDetection.Text;
            summaryPair += '\n';
          }
        });

        // Process LineItemGroups
        const lineItems = receipt.LineItemGroups?.[0]?.LineItems || [];
        lineItems.forEach((item) => {
          item.LineItemExpenseFields.forEach((expField) => {
            if (expField.Type.Text === "EXPENSE_ROW") {
              const x = expField.ValueDetection.Geometry.BoundingBox.Left * img.width;
              const y = expField.ValueDetection.Geometry.BoundingBox.Top * img.height;
              const width = expField.ValueDetection.Geometry.BoundingBox.Width * img.width;
              const height = expField.ValueDetection.Geometry.BoundingBox.Height * img.height;
              this.drawBoundingBox(ctx, x, y, width, height);

              rawText[i].push(expField.ValueDetection.Text);
            }
          });

          if (item.LineItemExpenseFields.length >= 2) {
            itemsData.push({
              item: item.LineItemExpenseFields[0].ValueDetection.Text,
              price: item.LineItemExpenseFields[1].ValueDetection.Text,
            });

            itemsPair +=  item.LineItemExpenseFields[0].ValueDetection.Text + "," + item.LineItemExpenseFields[1].ValueDetection.Text;
            itemsPair += '\n';
          }
        });
      });

      // Update messages if data exists
      messages.text = rawText.length === 0 ? (
            <div className="no-analysis">
                <p>No text was found</p>
            </div>
        ) : "";
      messages.receiptSummary = summaryData.length === 0 ? (
            <div className="no-analysis">
                <p>No receipts was found</p>
            </div>
        ) : "";
      messages.receiptItems = itemsData.length === 0 ? (
            <div className="no-analysis">
                <p>No items was found</p>
            </div>
        ) : "";

      this.setState({ rawText, summaryData, itemsData, messages, summaryPair, itemsPair });
    };
  };

  render() {
    const { rawText, summaryData, itemsData, messages } = this.state;
    const { type } = this.props;

    return (
        <>
            <canvas ref={this.canvasRef} style={{ display: "none" }} />
            {
                type === "text" ?
                    <div id="raw-text">
                    {
                        rawText.length > 0 ? 
                            rawText.map((lineArr, i) =>
                                lineArr.map((text, j) => (
                                <div key={`${i}-${j}`} className="text inline-text">
                                    {text}
                                </div>
                                ))
                            )
                        : 
                            messages.text
                    }
                    </div>
                : type === "form" ?
                    <div id="forms">{messages.forms}</div>
                : type === "table" ?
                    <div id="tables">{messages.tables}</div>
                : type === "receiptSummary" ?
                    <div id="receipt-summary">
                        {messages.receiptSummary && <div>{messages.receiptSummary}</div>}
                        {summaryData.length > 0 && (
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>Key</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {summaryData.map((row, i) => (
                                        <tr key={i}>
                                            <td>{row.key}</td>
                                            <td>{row.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                : type === "receiptItems" ?
                    <div id="receipt-items">
                        {messages.receiptItems && <div>{messages.receiptItems}</div>}
                        {itemsData.length > 0 && (
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsData.map((row, i) => (
                                    <tr key={i}>
                                        <td>{row.item}</td>
                                        <td>{row.price}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        )}
                    </div>
                :
                    <></>
            }
            <DownloadResults
                rawText={this.state.rawText}
                rawJson={this.state.rawJson}
                forms={this.state.formsPair}
                tables={this.state.tablesPair}
                items={this.state.itemsPair}
                summary={this.state.summaryPair}
            />
        </>
    );
  }
}

export default ImageReceipt;